module.exports = __webpack_public_path__ + "img/Dantam Hair 06.d2d85147.jpg";